const PREVENT_COURS_URL = "https://cors-anywhere.herokuapp.com/";

export { PREVENT_COURS_URL }